module.exports = __webpack_public_path__ + "static/freelancer-portfolio-web-plp-3cb4ab127f158b814b682b488a07817d.png";